import TokenResource from "./TokenResource";

export default class UserResource extends TokenResource {
	fullName = "";
	email = "";
	mobilePhone = "";
	streetAddress = "";
	streetAddress2 = "";
	postalCode = "";
	city = "";
	existsInBackoffice = false;
	needsKycInput = false;

	pk() {
		return this.fullName;
	}

	static url = () => {
		return UserResource.urlRoot;
	};

	static urlRoot = "/api/user";
}
